import { defineComponent as _defineComponent } from 'vue'
import { useConstantStore } from '@/helpers/composables/useStores';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JustwatchTVPlayBtn',
  props: {
    disable: { type: Boolean, default: false }
  },
  setup(__props: any) {


const { providersByShortName } = useConstantStore();

return { __sfc: true,providersByShortName, ProviderIcon }
}

})